import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  constructor() {}

  Set(key: string, value: any): any {
    localStorage[key] = JSON.stringify(value);
    return true;
  }

  Get(key: string): any {
    const value = localStorage[key];
    if (value) {
      return JSON.parse(value);
    } else return null;
  }

  Remove(key: string): any {
    localStorage.removeItem(key);
  }

  Clear(): void {
    localStorage.clear();
  }

  isAuth() {
    let token = this.Get('gis-token');
    if (token) {
      return true;
    }
    return false;
  }
}
